import { createContract } from '@exodus/ethereum-lib'
import assert from 'minimalistic-assert'

import {
  isPolygonClaimUndelegate,
  isPolygonDelegate,
  isPolygonUndelegate,
} from './staking/matic/index.js'
import { createStakingApi } from './staking-api.js'

const defaultTokenFeatures = {
  isMaxFeeAsset: true,
}

// Hide on both deposit and withdraw sides
const smallbalanceTx = (tx) => Math.abs(tx.coinAmount.toBaseNumber()) === 0

const getTxLogFilter = () => (tx) => !smallbalanceTx(tx)

const getPolygonTxLogFilter = () => (tx) =>
  isPolygonDelegate(tx) ||
  isPolygonClaimUndelegate(tx) ||
  isPolygonUndelegate(tx) ||
  getTxLogFilter()(tx)
const getPolygonActivityTxs = ({ txs }) =>
  txs.filter(
    (tx) =>
      isPolygonDelegate(tx) ||
      isPolygonClaimUndelegate(tx) ||
      isPolygonUndelegate(tx) ||
      !smallbalanceTx(tx)
  )
const getActivityTxs = ({ txs }) => txs.filter((tx) => !smallbalanceTx(tx))

const getCreateBaseToken =
  ({ getBalances, ...props }) =>
  ({ name, contract, features, ...tokenDef }) => {
    assert(getBalances, 'getBalances is required')
    const tokenSpecificFeatures = name === 'polygon' ? { staking: {} } : {}
    const tokenSpecificApiFunctions =
      name === 'polygon' ? { staking: createStakingApi({ network: name }) } : {}

    const tokenFeatures = { ...defaultTokenFeatures, ...features, ...tokenSpecificFeatures }
    return {
      ...tokenDef,
      addresses: contract,
      assetId: contract.current,
      contract: createContract(contract.current, name),
      gasLimit: 120_000,
      name,
      api: {
        getActivityTxs: name === 'polygon' ? getPolygonActivityTxs : getActivityTxs,
        features: tokenFeatures,
        hasFeature: (feature) => !!tokenFeatures[feature], // @deprecated use api.features instead
        getBalances,
        getTxLogFilter: name === 'polygon' ? getPolygonTxLogFilter : getTxLogFilter,
        ...tokenSpecificApiFunctions,
      },
      ...props, // override props above, add new props
    }
  }

export const createTokenFactory = (props, assets) => {
  const createBaseToken = getCreateBaseToken(props)
  const createCustomToken = ({ assetId, assetName, ...rest }) =>
    createBaseToken({ ...rest, name: assetName, contract: { current: assetId } })
  const createToken = (tokenDef) =>
    tokenDef.isBuiltIn ? createBaseToken(tokenDef) : createCustomToken(tokenDef)
  return {
    createToken,
    getTokens: () =>
      Object.values(assets)
        .filter((asset) => asset.name !== asset.baseAsset.name) // eslint-disable-next-line unicorn/no-array-callback-reference -- TODO: Fix this the next time the file is edited.
        .map(createToken),
  }
}
